import { autocompleteClasses, Box } from "@mui/material";

// mui theme settings
export const themeSettings = () => {
  return {
    palette: {
      primary: {
        dark: "#ba001c",
        main: "#DB0021",
        light: "#bea084",
        contrastText: "#fff",
      },
      text: {
        primary: "#000000",
        secondary: "#666666",
      },
    },
    typography: {
      fontFamily: ["Jost", "sans-serif"].join(","),
      fontSize: 12,
      h1: {
        fontFamily: ["Jost", "sans-serif"].join(","),
        fontSize: 40,
      },
      h2: {
        fontFamily: ["Jost", "sans-serif"].join(","),
        fontSize: 32,
      },
      h3: {
        fontFamily: ["Jost", "sans-serif"].join(","),
        fontSize: 24,
      },
      h4: {
        fontFamily: ["Jost", "sans-serif"].join(","),
        fontSize: 20,
      },
      h5: {
        fontFamily: ["Jost", "sans-serif"].join(","),
        fontSize: 16,
      },
      h6: {
        fontFamily: ["Jost", "sans-serif"].join(","),
        fontSize: 14,
      },
      medium: {
        fontFamily: ["Jost", "sans-serif"].join(","),
        fontSize: 12,
      },
      small: {
        fontFamily: ["Jost", "sans-serif"].join(","),
        fontSize: 10,
      },
    },
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            // Outlined
            "& .MuiOutlinedInput-root": {
              fontSize: "12px",
            },
            "& .MuiInputLabel-outlined": {
              fontSize: "12px",
            },
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          rounded: { border: ".0625rem solid #DB0021" },
        },
      },
      MuiAutocomplete: {
        defaultProps: {
          renderOption: (props, option, state, ownerState) => {
            const { key, ...optionProps } = props;
            return (
              <Box
                key={key}
                sx={{
                  fontSize: "12px",
                  borderRadius: "2px",
                  margin: "2px",
                  [`&.${autocompleteClasses.option}`]: {
                    padding: "8px",
                  },
                }}
                component="li"
                {...optionProps}
              >
                {ownerState.getOptionLabel(option)}
              </Box>
            );
          },
        },
      },
    },
  };
};
